import { ReactNode } from "react";
import { Dentist, Patient } from "@jasper/client-models";
import { SimpleGrid, Stack, Text } from "@mantine/core";
import { getAge, getDentistName, getGenderLabel } from "../patient.utils";

const getProfileText = ({ birthDate, sex }: Patient) => {
  const parts = [
    sex ? getGenderLabel(sex) : null,
    birthDate ? `${getAge(birthDate)} ans` : null,
  ].filter(Boolean);

  return parts.length > 0 ? parts.join(" · ") : "Non renseigné";
};

const ReviewField = ({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) => {
  return (
    <Stack gap="s1">
      <Text variant="eyebrow" c="dimmed">
        {label}
      </Text>
      <Text>{children}</Text>
    </Stack>
  );
};

export const PatientSection = ({
  patient,
  dentist,
}: {
  patient: Patient;
  dentist: Dentist;
}) => {
  return (
    <SimpleGrid cols={2} spacing="xl" verticalSpacing="md">
      <ReviewField label="Nom">
        {patient.firstName} {patient.lastName}
      </ReviewField>
      <ReviewField label="Profil">{getProfileText(patient)}</ReviewField>
      <ReviewField label="Praticien">{getDentistName(dentist)}</ReviewField>
    </SimpleGrid>
  );
};
